import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";
import DashboardLayout from "./dashboardLayout/dashboardLayout";

const Main = lazy(() => import("../components/welcome/main"));


const Welcome = () => {
    return (
        <DashboardLayout>
            <Suspense fallback={<CircularLoader />}>
                <Main />
            </Suspense>
        </DashboardLayout>
    )
}
export default Welcome;